import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const MobileAppSection: React.FC = () => {
  return (
    <SectionBackground style={{
      padding: '60px 20px',
      background: 'linear-gradient(135deg, #1F2937 0%, #111827 100%)',
      color: 'white',
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '60px',
          alignItems: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
        }}>
          <div>
            <h2 style={{ fontSize: '2.5rem', marginBottom: '30px', fontWeight: 700 }}>
              Manage Leases On-The-Go
            </h2>
            <p style={{ fontSize: '1.2rem', lineHeight: 1.8, marginBottom: '30px', opacity: 0.9 }}>
              Mobile apps for iOS and Android coming in 2026. Create, send, and sign leases from anywhere.
            </p>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <div style={{
                background: 'rgba(255,255,255,0.1)',
                padding: '15px 30px',
                borderRadius: '999px',
                border: '1px solid rgba(255,255,255,0.2)',
                color: 'white',
                fontWeight: 600,
              }}>
                📱 iOS App Store
              </div>
              <div style={{
                background: 'rgba(255,255,255,0.1)',
                padding: '15px 30px',
                borderRadius: '999px',
                border: '1px solid rgba(255,255,255,0.2)',
                color: 'white',
                fontWeight: 600,
              }}>
                🤖 Google Play
              </div>
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div
              className="cb-phone-mockup"
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: '2px solid rgba(255,255,255,0.2)',
                margin: '0 auto'
              }}
            >
              <div
                className="cb-phone-screen"
                style={{
                  background: 'transparent',
                  borderRadius: '28px',
                  border: '1px dashed rgba(255,255,255,0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white'
                }}
              >
                <span style={{ opacity: 0.7 }}>Mobile mockup coming soon</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionBackground>
  );
};

export default MobileAppSection; 
